import { PerformanceDataViewType } from '../models/performance-data-view-type.enum';
import { TranslationKeyMap } from '../my-performance-card.i18n';

export const PerformanceDataViewTypeTranslationMap = {
    [PerformanceDataViewType.MARKET]: TranslationKeyMap._832_MARKET,
    [PerformanceDataViewType.SITE]: TranslationKeyMap._64_SITE,
    [PerformanceDataViewType.PEER_GROUP]: TranslationKeyMap._824_PEER_GROUP,
    [PerformanceDataViewType.SITE_PEER_GROUP]:
        TranslationKeyMap._9937_SITE_PEER_GROUP,
    [PerformanceDataViewType.SUPER_GROUP]: TranslationKeyMap._67_SUPER_GROUP,
    [PerformanceDataViewType.SITE_SUPER_GROUP]:
        TranslationKeyMap._9938_SITE_SUPER_GROUP,
    [PerformanceDataViewType.USER_SUPER_GROUP]:
        TranslationKeyMap._9939_USER_SUPER_GROUP,
    [PerformanceDataViewType.AREA_PEER_GROUP]:
        TranslationKeyMap._9940_AREA_PEER_GROUP,
    [PerformanceDataViewType.REGION_SUPER_GROUP]:
        TranslationKeyMap._9941_REGION_SUPER_GROUP,
    [PerformanceDataViewType.AREA_LOB]: TranslationKeyMap._9930_AREA_LOB,
    [PerformanceDataViewType.REGION_LOB]: TranslationKeyMap._9931_REGION_LOB,
    [PerformanceDataViewType.TEAM_SUPER_GROUP]:
        TranslationKeyMap._9932_TEAM_SUPER_GROUP,
    [PerformanceDataViewType.AREA]: TranslationKeyMap._148_AREA,
    [PerformanceDataViewType.REGION]: TranslationKeyMap._149_REGION,
    [PerformanceDataViewType.USER]: TranslationKeyMap._656_USER,
    [PerformanceDataViewType.SITE_LOB]: TranslationKeyMap._9933_SITE_LOB,
    [PerformanceDataViewType.LOB]: TranslationKeyMap._583_LOB,
    [PerformanceDataViewType.USER_QUEUE]: TranslationKeyMap._9934_USER_QUEUE,
    [PerformanceDataViewType.SUPER_GROUP_QUEUE]:
        TranslationKeyMap._9935_SUPER_GROUP_QUEUE,
    [PerformanceDataViewType.SITE_SUPER_GROUP_QUEUE]:
        TranslationKeyMap._9936_SITE_SUPER_GROUP_QUEUE,
};
